/*global jQuery*/
/**
 * {{name}}
 * Global JS
 *
 * version: {{version}}
 * file:    {{file}}
 * author:  Squiz Australia
 * change log:
 *     {{date}} - First revision
 */

/*
 * Table of Contents
 *
 * - Global
 * - Modules
{{toc}}
 */
"use strict";
/*
--------------------
Global
--------------------
*/
//  Declare JS Enabled.
$("body")
  .removeClass("no-js")
  .addClass("js-enabled");

$(".scroll-link").click(function() {
  var $block = $(
    'a[name="' +
      $(this)
        .attr("href")
        .substr(1) +
      '"]'
  );

  $("html, body").animate(
    {
      scrollTop: $block.offset().top
    },
    300
  );

  return false;
});

$(document).ready(function() {
  const $side_link_item = $(".side-navigation__link"),
    $sub_link_list = $(".side-navigation__list "),
    $sub_link_item = $(".side-navigation__list li");
  $sub_link_list.each(function() {
    if ($(this) != undefined) {
      $(this)
        .prev("div.side-navigation__link")
        .find(".side-navigation__toggle")
        .removeClass("hidden");
      if (
        $(this)
          .prev("div.side-navigation__link")
          .hasClass("current")
      ) {
        $(this).addClass("active");
        $(this)
          .prev("div.side-navigation__link")
          .find(".side-navigation__toggle")
          .addClass("active");
      }
      if (
        $(this)
          .find("li")
          .hasClass("current")
      ) {
        $(this)
          .prev("div.side-navigation__link")
          .removeClass("current");
      }
    }
  });

  $(".navigation__level-3").each(function() {
    if ($(this).length == 1) {
      $(this)
        .parent()
        .find(".navigation__toggle")
        .removeClass("hidden");
    }
  });
});
/*
--------------------
Modules
--------------------
*/

/**
 * Offset Anchor Link Jump.
 */

(function(document, history, location) {
  var HISTORY_SUPPORT = !!(history && history.pushState);

  var anchorScrolls = {
    ANCHOR_REGEX: /^#[^ ]+$/,
    OFFSET_HEIGHT_PX: $("header").height(),
    IS_ALERT_ACTIVE: $(".js-alert").is(":visible"),

    /**
     * Establish events, and fix initial scroll position if a hash is provided.
     */
    init: function() {
      this.scrollToCurrent();
      window.addEventListener("hashchange", this.scrollToCurrent.bind(this));
      document.body.addEventListener("click", this.delegateAnchors.bind(this));
    },

    /**
     * Return the offset amount to deduct from the normal scroll position.
     * Modify as appropriate to allow for dynamic calculations
     */
    getFixedOffset: function() {
      this.OFFSET_HEIGHT_PX = $("header").height();
      this.IS_ALERT_ACTIVE = $(".js-alert").is(":visible");
      return this.OFFSET_HEIGHT_PX;
    },

    /**
     * If the provided href is an anchor which resolves to an element on the
     * page, scroll to it.
     * @param  {String} href
     * @return {Boolean} - Was the href an anchor.
     */
    scrollIfAnchor: function(href, pushToHistory) {
      var match, rect, anchorOffset;

      if (!this.ANCHOR_REGEX.test(href)) {
        return false;
      }

      match = document.getElementById(href.slice(1));

      if (match) {
        rect = match.getBoundingClientRect();
        anchorOffset = window.pageYOffset + rect.top - this.getFixedOffset();
        window.scrollTo(window.pageXOffset, anchorOffset);

        // Add the state to history as-per normal anchor links
        if (HISTORY_SUPPORT && pushToHistory) {
          history.pushState({}, document.title, location.pathname + href);
        }
      }

      return !!match;
    },

    /**
     * Attempt to scroll to the current location's hash.
     */
    scrollToCurrent: function() {
      this.scrollIfAnchor(window.location.hash);
    },

    /**
     * If the click event's target was an anchor, fix the scroll position.
     */
    delegateAnchors: function(e) {
      var elem = e.target;

      if (
        elem.nodeName === "A" &&
        this.scrollIfAnchor(elem.getAttribute("href"), true)
      ) {
        e.preventDefault();
      }
    }
  };

  window.addEventListener(
    "DOMContentLoaded",
    anchorScrolls.init.bind(anchorScrolls)
  );
})(window.document, window.history, window.location);
